/**
 * @generated SignedSource<<b88844f28b9b182350466a15abf890eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgUserInviteQuery$variables = Record<PropertyKey, never>;
export type OrgUserInviteQuery$data = {
  readonly organisation: {
    readonly workspaces: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"OrgUserEditAccessSelect_workspaces" | "WorkspaceRolesSelector_workspaces">;
    }>;
  };
};
export type OrgUserInviteQuery = {
  response: OrgUserInviteQuery$data;
  variables: OrgUserInviteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgUserInviteQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Workspace",
              "kind": "LinkedField",
              "name": "workspaces",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OrgUserEditAccessSelect_workspaces"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceRolesSelector_workspaces"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgUserInviteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subWorkspaceCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fad5d039e330c99f3819deecb5f8093a",
    "id": null,
    "metadata": {},
    "name": "OrgUserInviteQuery",
    "operationKind": "query",
    "text": "query OrgUserInviteQuery {\n  organisation {\n    workspaces {\n      ...OrgUserEditAccessSelect_workspaces\n      ...WorkspaceRolesSelector_workspaces\n      id\n    }\n    id\n  }\n}\n\nfragment OrgUserEditAccessSelect_workspaces on Workspace {\n  id\n  name\n  subWorkspaceCount\n  ...WorkspaceSelectorContent_workspaces\n}\n\nfragment WorkspaceRolesSelector_workspaces on Workspace {\n  ...OrgUserEditAccessSelect_workspaces\n}\n\nfragment WorkspaceSelectorContent_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n"
  }
};
})();

(node as any).hash = "3125ae7397d0fa790c8ef4c151914605";

export default node;
